import React from 'react';
import { Link } from 'react-router-dom';
const footerData = [{
  title: 'Platform',
  links: [{
    label: 'Platform Overview',
    to: '/platform'
  }, {
    label: 'Breach and Attack Simulation',
    to: '/breach-and-attack-simulation'
  }, {
    label: 'Exposure Validation',
    to: '/platform/exposure-validation'
  }, {
    label: 'Automated Penetration Testing',
    to: '/platform/automated-penetration-testing'
  }, {
    label: 'Picus Swarm',
    to: '/platform/picus-swarm'
  }, {
    label: 'Integrations',
    to: '/integrations'
  }, {
    label: 'Picus vs. Alternatives',
    to: '/platform/picus-vs-alternatives'
  }]
}, {
  title: 'Use Cases',
  links: [{
    label: 'Emerging Threat Response',
    to: '/use-cases/emerging-threat-response'
  }, {
    label: 'Validate Security Controls',
    to: '/use-cases/validate-security-controls'
  }, {
    label: 'Validate Detection Rules',
    to: '/use-cases/validate-detection-rules'
  }, {
    label: 'Prioritize Real Exposure',
    to: '/use-cases/prioritize-real-exposure'
  }, {
    label: 'Reduce Manual Overhead',
    to: '/use-cases/reduce-manual-triage'
  }, {
    label: 'Accelerate Remediation',
    to: '/use-cases/accelerate-remediation'
  }, {
    label: 'Prove Compliance',
    to: '/use-cases/prove-compliance'
  }, {
    label: 'Validate AI Security',
    to: '/use-cases/ai-security-validation'
  }, {
    label: 'Prove Readiness',
    to: '/use-cases/prove-readiness'
  }, {
    label: 'Automate Penetration Testing',
    to: '/use-cases/automate-penetration-testing'
  }]
}, {
  title: 'Industries',
  links: [{
    label: 'Financial Services',
    to: '/industries/financial-services'
  }, {
    label: 'Healthcare',
    to: '/industries/healthcare'
  }, {
    label: 'IT / OT',
    to: '/industries/it-ot'
  }, {
    label: 'Critical Infrastructure',
    to: '/industries/critical-infrastructure'
  }, {
    label: 'Manufacturing',
    to: '/industries/manufacturing'
  }, {
    label: 'Retail / eCommerce',
    to: '/industries/retail-ecommerce'
  }, {
    label: 'Public Sector',
    to: '/industries/public-sector'
  }, {
    label: 'Technology / SaaS',
    to: '/industries/technology-saas'
  }]
}, {
  title: 'Frameworks & Compliance',
  links: [{
    label: 'CTEM',
    to: '/frameworks-and-compliance/ctem'
  }, {
    label: 'MITRE ATT&CK',
    to: '/frameworks-and-compliance/mitre-attack'
  }, {
    label: 'NIST CSF',
    to: '/frameworks-and-compliance/nist-csf'
  }, {
    label: 'HIPAA',
    to: '/frameworks-and-compliance/hipaa'
  }, {
    label: 'PCI DSS',
    to: '/frameworks-and-compliance/pci-dss'
  }, {
    label: 'DORA',
    to: '/frameworks-and-compliance/dora'
  }, {
    label: 'NIS2',
    to: '/frameworks-and-compliance/nis2'
  }, {
    label: 'ASEAN Cyber',
    to: '/frameworks-and-compliance/asean-cyber'
  }, {
    label: 'MAS TRM',
    to: '/frameworks-and-compliance/mas-trm'
  }]
}, {
  title: 'Research & Resources',
  links: [{
    label: 'Red Report',
    to: '/research/red-report'
  }, {
    label: 'Blue Report',
    to: '/research/blue-report'
  }, {
    label: 'Purple Academy',
    to: '/resources/purple-academy'
  }, {
    label: 'Threat Response Index',
    to: '/research/threat-response-index'
  }, {
    label: 'Picus Labs',
    to: '/research/picus-labs'
  }, {
    label: 'Emerging Threats',
    to: '/research/emerging-threats'
  }, {
    label: 'Blogs',
    to: '/resources/blogs'
  }, {
    label: 'Glossary',
    to: '/resources/glossary'
  }, {
    label: 'Events',
    to: '/resources/events'
  }, {
    label: 'All Resources',
    to: '/resources'
  }]
}, {
  title: 'Company',
  links: [{
    label: 'About',
    to: '/company/about'
  }, {
    label: 'Customers',
    to: '/company/customers'
  }, {
    label: 'Partners',
    to: '/company/partners'
  }, {
    label: 'Careers',
    to: '/company/careers'
  }, {
    label: 'Contact',
    to: '/contact'
  }]
}];
export function Footer() {
  return <footer className="bg-picus-surface" data-id="element-158">
      <div className="max-w-[1280px] mx-auto border-t border-picus-border" data-id="element-159">
        <div className="p-2 border-b border-picus-border" data-id="element-160">
          <div className="border border-picus-border p-8 md:p-24" data-id="element-161">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-16" data-id="element-162">
              {/* Column 1 */}
              <div className="flex flex-col gap-16" data-id="element-163">
                <div className="flex flex-col gap-3" data-id="element-164">
                  <h4 className="font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] text-white mb-4" data-id="element-165">
                    Platform
                  </h4>
                  <Link to="/platform" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-166">
                    Platform Overview
                  </Link>
                  <Link to="/platform/picus-swarm" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-167">
                    Picus Swarm
                  </Link>
                  <Link to="/frameworks-and-compliance/ctem" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-168">
                    What is CTEM
                  </Link>
                  <Link to="/platform/picus-vs-alternatives" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-169">
                    Picus vs Alternatives
                  </Link>
                  <Link to="/platform/exposure-validation" className="font-mono text-[12px] leading-[16px] font-semibold uppercase tracking-[2px] text-picus-mutedSecondary hover:text-white transition-colors mt-2" data-id="element-170">
                    What is Autonomous Exposure Validation
                  </Link>
                </div>
                <div className="flex flex-col gap-3" data-id="element-171">
                  <h4 className="font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] text-white mb-4" data-id="element-172">
                    Integrations
                  </h4>
                  <Link to="/integrations/crowdstrike" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-173">
                    Crowdstrike
                  </Link>
                  <Link to="/integrations/palo-alto" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-174">
                    Palo Alto
                  </Link>
                  <Link to="/integrations/microsoft" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-175">
                    Microsoft
                  </Link>
                  <Link to="/integrations/sentinelone" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-176">
                    SentinelOne
                  </Link>
                  <Link to="/integrations/splunk" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-177">
                    Splunk
                  </Link>
                  <Link to="/integrations/ibm" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-178">
                    IBM
                  </Link>
                  <Link to="/integrations/tenable" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-179">
                    Tenable
                  </Link>
                  <Link to="/integrations/servicenow" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-180">
                    ServiceNow
                  </Link>
                </div>
              </div>

              {/* Column 2 */}
              <div className="flex flex-col gap-16" data-id="element-181">
                <div className="flex flex-col gap-3" data-id="element-182">
                  <h4 className="font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] text-white mb-4" data-id="element-183">
                    Use Cases
                  </h4>
                  <Link to="/breach-and-attack-simulation" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-184">
                    Breach and Attack Simulation
                  </Link>
                  <Link to="/platform/automated-penetration-testing" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-185">
                    Automated Pentesting
                  </Link>
                  <Link to="/platform/exposure-validation" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-186">
                    Exposure Validation
                  </Link>
                  <Link to="/use-cases/attack-surface-management" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-187">
                    Attack Surface Management
                  </Link>
                  <Link to="/use-cases/ai-security-validation" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-188">
                    AI Security Validation
                  </Link>
                  <Link to="/use-cases/validate-detection-rules" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-189">
                    Detection Rule Validation
                  </Link>
                  <Link to="/use-cases/cyber-risk-quantification" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-190">
                    Cyber Risk Quantification
                  </Link>
                  <Link to="/use-cases/automated-security-control-assessment" className="font-mono text-[12px] leading-[16px] font-semibold uppercase tracking-[2px] text-picus-mutedSecondary hover:text-white transition-colors mt-2" data-id="element-191">
                    Automated Security Control Assessment
                  </Link>
                </div>
                <div className="flex flex-col gap-3" data-id="element-192">
                  <h4 className="font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] text-white mb-4" data-id="element-193">
                    Industries
                  </h4>
                  <Link to="/industries/financial-services" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-194">
                    Banking and Financial Services
                  </Link>
                  <Link to="/industries/critical-infrastructure" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-195">
                    Energy and Critical Infrastructure
                  </Link>
                  <Link to="/industries/healthcare" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-196">
                    Healthcare
                  </Link>
                  <Link to="/industries/public-sector" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-197">
                    Public Sector
                  </Link>
                  <Link to="/industries/manufacturing" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-198">
                    Manufacturing
                  </Link>
                </div>
              </div>

              {/* Column 3 */}
              <div className="flex flex-col gap-3" data-id="element-199">
                <h4 className="font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] text-white mb-4" data-id="element-200">
                  Resources
                </h4>
                <Link to="/research/red-report" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-201">
                  Red Report
                </Link>
                <Link to="/research/blue-report" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-202">
                  Blue Report
                </Link>
                <Link to="/resources/purple-academy" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-203">
                  Purple Academy
                </Link>
                <Link to="/research/emerging-threats" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-204">
                  Emerging Threats
                </Link>
                <Link to="/resources/webinars" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-205">
                  Webinars
                </Link>
                <Link to="/resources/case-studies" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-206">
                  Case Studies
                </Link>
                <Link to="/resources/datasheets" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-207">
                  Datasheets
                </Link>
                <Link to="/resources/glossary" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-208">
                  Glossary
                </Link>
                <Link to="/resources/events" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-209">
                  Events
                </Link>
                <Link to="/resources/blogs" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-210">
                  Blog
                </Link>
              </div>

              {/* Column 4 */}
              <div className="flex flex-col gap-16" data-id="element-211">
                <div className="flex flex-col gap-3" data-id="element-212">
                  <h4 className="font-mono text-[14px] leading-[16px] font-medium uppercase tracking-[2px] text-white mb-4" data-id="element-213">
                    Company
                  </h4>
                  <Link to="/company/about" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-214">
                    About Picus
                  </Link>
                  <Link to="/company/newsroom" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-215">
                    Newsroom
                  </Link>
                  <Link to="/company/careers" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-216">
                    Careers
                  </Link>
                  <Link to="/company/leadership" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-217">
                    Leadership
                  </Link>
                  <Link to="/contact" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-218">
                    Contact
                  </Link>
                </div>
                <div className="flex flex-col gap-3" data-id="element-219">
                  <div className="flex flex-wrap gap-x-2 gap-y-1" data-id="element-220">
                    <Link to="/company/partners" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-221">
                      Partners
                    </Link>
                    <span className="text-picus-mutedSecondary" data-id="element-222">|</span>
                    <Link to="/company/partners/become" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-223">
                      Become a Partner
                    </Link>
                    <span className="text-picus-mutedSecondary" data-id="element-224">|</span>
                    <Link to="/company/partners/program" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-225">
                      Picus Partner Program
                    </Link>
                    <span className="text-picus-mutedSecondary" data-id="element-226">|</span>
                    <Link to="/company/partners/login" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-227">
                      Partner Login
                    </Link>
                    <span className="text-picus-mutedSecondary" data-id="element-228">|</span>
                    <Link to="/company/partners/alliances" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-229">
                      Alliances
                    </Link>
                  </div>
                </div>
                <div className="flex flex-col gap-3" data-id="element-230">
                  <div className="flex flex-wrap gap-x-2 gap-y-1" data-id="element-231">
                    <Link to="/trust" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-232">
                      Trust Center
                    </Link>
                    <span className="text-picus-mutedSecondary" data-id="element-233">|</span>
                    <Link to="/terms" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-234">
                      Terms
                    </Link>
                    <span className="text-picus-mutedSecondary" data-id="element-235">|</span>
                    <Link to="/privacy" className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-236">
                      Security & Privacy
                    </Link>
                    <span className="text-picus-mutedSecondary" data-id="element-237">|</span>
                    <button className="font-mono text-[16px] leading-[24px] text-picus-mutedSecondary hover:text-white transition-colors" data-id="element-238">
                      Cookie Settings
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-2" data-id="element-239">
          <div className="border border-picus-border px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-240">
            <div className="font-mono text-[12px] leading-[16px] font-semibold uppercase tracking-[2px] text-white" data-id="element-241">
              &copy; {new Date().getFullYear()} Copyright. All rights reserved.
            </div>
            <Link to="/" className="flex-shrink-0" data-id="element-242">
              <span className="font-sans text-[20px] font-medium tracking-[4px] uppercase text-white" data-id="element-243">
                Picus
              </span>
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}